import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/shadcn/ui/form';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem, SelectLabel, SelectGroup } from '@/components/shadcn/ui/select';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { Textarea } from '@/components/shadcn/ui/textarea';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/shadcn/ui/popover';
import { Button } from '@/components/shadcn/ui/button';
import { CalendarIcon } from 'lucide-react';
import { Calendar } from '@/components/shadcn/ui/calendar';
import { cn } from '@/lib/utils';
import { format } from 'date-fns';
import { fi, ptBR } from 'date-fns/locale';
import { RadioGroup, RadioGroupItem } from '@/components/shadcn/ui/radio-group';
import { Switch } from '@/components/shadcn/ui/switch';
import { useActivityTypeContext } from '@/pages/configurations/activities/type/ActivityTypeContext';
import { Mention, MentionsInput } from 'react-mentions';
import mentionStyles from '../../Form/mentionStyles';

import { useActivityType } from '@/hook/useActivityType';
import { useUsers } from '@/hook/useUsers';
import { useTasks } from '@/hook/useTasks';
import { useParams } from 'react-router-dom';
import { setPriority } from 'os';
import { useAuthContext } from '@/context/AuthContext';
import { useTaskContext } from '@/context/TaskContext';

const responsavel = [
  { id: 1, display: 'Chico' },
  { id: 2, display: 'Beltrão' },
  { id: 3, display: 'Maria' }
];

const dones = [
  { id: 'S', display: 'Sim' },
  { id: 'N', display: 'Não' },
];

type TypeType = {
  id: number;
  description: string;
}[]

type FormTarefaProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onTaskSubmit: (data: any, index: number | undefined) => void;
  index: number | undefined;
  open:boolean;
};

const schema = z.object({
  id:z.number(),
  description: z.string(),
  businessId: z.number(),
  // accountable: z.string(),
  activityType: z.string(),
  userName:z.string(),
  activityTypesId: z.number(),
  userId: z.number(),
  prevision: z.date().optional(),
  iniciatedAt:z.date(),
  notification: z.boolean(),
  observation: z.string(),
  setPriority: z.string(),
  priority: z.number(),
  // setNotification: z.boolean().optional(),
  situation: z.number(),
  done: z.string(),
  companyId: z.number(),
  conclusionAt: z.date().optional(),
  userWhoAdds: z.string()
  
});
  
const FormTarefa: React.FC<FormTarefaProps> = ({ onTaskSubmit, index, open }) => {

  const { activityTypes } = useActivityType();
  const {users} = useUsers();
  const leadId = Number(useParams().leadId);
  const [types, setTypes] = useState<TypeType>([]);
  const [openDtConclusion, setOpenDtConclusion] = useState(false);
  const [openDtInicio, setOpenDtInicio] = useState(false);
  const [openDtPrevision, setOpenDtPrevision] =useState(false);
  const {accessToken} = useAuthContext();
  const {dataTaskEdit, setDataTaskEdit, isCompleted, setIsCompleted} = useTaskContext();
  
  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
  });

  const loggedUser = users.find((u)=>u.userId === accessToken?.userId)?.name;

  useEffect(() => {
    const iniciatedAtValue = form.getValues('iniciatedAt');

    // Se o valor de 'iniciatedAt' mudar, limpar o valor de 'prevision'
    if (iniciatedAtValue) {
      
      form.setValue('conclusionAt', undefined);
      form.setValue('prevision', undefined);
    }
  }, [form.getValues('iniciatedAt')]);

  useEffect(()=>{
    if(!dataTaskEdit) return;
    form.setValue('id', dataTaskEdit ? dataTaskEdit.id : '');
    form.setValue('description', dataTaskEdit ? dataTaskEdit.description : '');
    form.setValue('businessId', dataTaskEdit ? dataTaskEdit.businessId : '');
    form.setValue('activityType', dataTaskEdit ? dataTaskEdit.activityType : '');
    form.setValue('userName', dataTaskEdit ? dataTaskEdit.userName : '');
    form.setValue('activityTypesId', dataTaskEdit ? dataTaskEdit.activityTypesId : '');
    form.setValue('userId', dataTaskEdit ? dataTaskEdit.userId : '');
    form.setValue('prevision', dataTaskEdit ? dataTaskEdit.prevision : '');
    form.setValue('iniciatedAt', dataTaskEdit ? dataTaskEdit.iniciatedAt : '');
    form.setValue('notification', dataTaskEdit ? dataTaskEdit.notification : '');
    form.setValue('observation', dataTaskEdit ? dataTaskEdit.observation : '');
    form.setValue('setPriority', dataTaskEdit ? dataTaskEdit.setPriority : '');
    form.setValue('priority', dataTaskEdit ? dataTaskEdit.priority : '');
    form.setValue('situation', dataTaskEdit ? dataTaskEdit.situation : '');
    form.setValue('done', dataTaskEdit ? dataTaskEdit.done : '');
    form.setValue('companyId', dataTaskEdit ? dataTaskEdit.companyId : '');
    form.setValue('conclusionAt', dataTaskEdit ? dataTaskEdit.conclusionAt : '');
    form.setValue('userWhoAdds', dataTaskEdit ? dataTaskEdit.userWhoAdds : '');
  },[dataTaskEdit]);

  if(dataTaskEdit){
    if(dataTaskEdit.priority === 0){
      dataTaskEdit.setPriority = 'Baixa';
    }else if(dataTaskEdit.priority === 1){
      dataTaskEdit.setPriority = 'Normal';
    }else if(dataTaskEdit.priority === 2){
      dataTaskEdit.setPriority='Alta';
    }
    if(dataTaskEdit.notification){
      dataTaskEdit.setNotification = true;
    } else{
      dataTaskEdit.setNotification = false;
    }
    form.setValue('conclusionAt', dataTaskEdit.conclusionAt);
    form.setValue('prevision', dataTaskEdit.prevision);
    form.setValue('iniciatedAt', dataTaskEdit.iniciatedAt);
    // if(dataTaskEdit){}
  }

  const buttonLabel =  index !== undefined ? 'Editar Tarefa' : 'Criar Tarefa';
  // const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
  //   event.preventDefault();
  //   const formData = form.getValues();
  //   onTaskSubmit(formData);
  //   console.log('formData:',formData);
  const formData = form.getValues();
  // };

  const handleFormSubmit = () => {
    form.setValue('businessId', leadId);
    form.setValue('situation', 1);
    form.setValue('userWhoAdds', loggedUser ? loggedUser : '');
  
    if (form.getValues().done === 'S') {
      setIsCompleted(true);
    } else {
      setIsCompleted(false);
    }
  
    if (form.getValues().setPriority === 'Baixa') {
      form.setValue('priority', 0);
    } else if (form.getValues().setPriority === 'Normal') {
      form.setValue('priority', 1);
    } else if (form.getValues().setPriority === 'Alta') {
      form.setValue('priority', 2);
    }
  
    if (!form.getValues().iniciatedAt) {
      form.setValue('prevision', undefined);
      form.setValue('conclusionAt', undefined);
    }
  
    if (form.getValues().activityTypesId) {
      const type = types.find((t) => t.id === Number(form.getValues().activityTypesId))?.description;
      if (type) form.setValue('activityType', type);
    }
  
    if (form.getValues().userId) {
      const name = users.find((u) => u.userId === Number(form.getValues().userId))?.name;
      if (name) form.setValue('userName', name);
    }
  
    // Now submit the form
    const formData = form.getValues();
    onTaskSubmit(formData, index);
  };
  
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleFormSubmit();
  };

  useEffect(() => {
    const newTypes = activityTypes.map((type, index) => ({
      id: type.id,
      description: type.name,
    }));
    // console.log('types:', activityTypes);
    setTypes(newTypes);
  }, [activityTypes]);

  return (
    <div>
      <Form {...form}>
        <form onSubmit={handleSubmit} className='py-2 flex flex-col gap-6'>
          {/** Descrição */}
          <FormField
            control={form.control}
            name="description"
            render={({ field }) => (
              <FormItem className='flex flex-col w-full'>
                <FormLabel>Descrição</FormLabel>
                <FormControl>
                  <Textarea
                    placeholder="Descrição da tarefa"
                    className="resize-none"
                    defaultValue={dataTaskEdit ? dataTaskEdit.description : ''}
                    {...field}
                  />
                </FormControl>
              </FormItem>
            )}
          />

          {/** Resonsavel */}
          <FormField
            control={form.control}
            name='userId'
            render={({ field }) => (
              <FormItem>
                <FormLabel>Responsável</FormLabel>
                <FormControl>
                  <Select onValueChange={field.onChange}>
                    <SelectTrigger>
                      <SelectValue placeholder={dataTaskEdit ? dataTaskEdit.userName : 'Selecione o responsável'} />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        {users.map((user, index) => (
                          <SelectItem 
                            key={index} 
                            value={user.userId.toString()}
                            defaultValue={dataTaskEdit ? dataTaskEdit.userId : ''}
                          >
                            <SelectLabel onSelect={()=>{
                              form.setValue('userName', user.name);
                            }} className='p-2 font-normal'>{user.name}</SelectLabel>
                          </SelectItem>
                        ))}
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          {/** Data de Ínicio */}
          <div className='w-full flex mt-1 gap-10 justify-start'>
            <FormField
              control={form.control}
              name="iniciatedAt"
              render={({ field }) => (
                <FormItem className="flex flex-col ">
                  <FormLabel className='py-1'>Data de Ínicio</FormLabel>
                  <Popover open={openDtInicio} onOpenChange={setOpenDtInicio}>
                    <PopoverTrigger asChild>
                      <FormControl>
                        <Button
                          variant={'outline'}
                          className={cn(
                            'w-full pl-3 text-left font-normal',
                            !field.value && 'text-muted-foreground'
                          )}
                        >
                          {field.value ? (
                            format(field.value, 'PPP',  {locale: ptBR})
                          ) : (
                            <span>Escolha uma data</span>
                          )}
                          <CalendarIcon className="ml-1 h-4 w-4 opacity-50" />
                        </Button>
                      </FormControl>
                    </PopoverTrigger>
                    <PopoverContent className="w-auto p-0" align="start">
                      <Calendar
                        mode="single"
                        selected={field.value}
                        onSelect={field.onChange}
                        onDayClick={(date) => {
                          setOpenDtInicio(false);
                          form.setValue('iniciatedAt', date);
                          setDataTaskEdit(form.getValues());
                        }}
                        // disabled={(date) => date < new Date()}
                        initialFocus
                        locale={ptBR}
                      />
                    </PopoverContent>
                  </Popover>
                  <FormMessage />
                </FormItem>
              )}
            />

            {/** Data de Conclusão*/}
            <FormField
              control={form.control}
              name="conclusionAt"
              render={({ field }) => (
                <FormItem className="flex flex-col">
                  <FormLabel className='py-1'>Data de Conclusão</FormLabel>
                  <Popover open={openDtConclusion} onOpenChange={setOpenDtConclusion}>
                    <PopoverTrigger asChild>
                      <FormControl>
                        <Button
                          variant={'outline'}
                          className={cn(
                            'w-full pl-3 text-left font-normal',
                            !field.value && 'text-muted-foreground'
                          )}
                        >
                          {field.value ? (
                            format(field.value, 'PPP', {locale: ptBR})
                          ) : (
                            <span>Escolha uma data</span>
                          )}
                          <CalendarIcon className="ml-1 h-4 w-4 opacity-50" />
                        </Button>
                      </FormControl>
                    </PopoverTrigger>
                    <PopoverContent className="w-auto p-0" align="start">
                      <Calendar
                        mode="single"
                        selected={field.value}
                        onSelect={field.onChange}
                        onDayClick={(date) => {
                          setOpenDtConclusion(false);
                          form.setValue('conclusionAt', date);
                          setDataTaskEdit(form.getValues());
                        }}
                        disabled={(date) => {
                          const dtinicio = form.getValues().iniciatedAt;
                          if (!dtinicio) return true;
                          
                          return date < dtinicio;
                        }}
                        
                        initialFocus
                        locale={ptBR}
                      />
                    </PopoverContent>
                  </Popover>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          {/* Previsão */}
          <FormField
            control={form.control}
            name="prevision"
            render={({ field }) => (
              <FormItem className="flex flex-col">
                <FormLabel className='py-1'>Previsão</FormLabel>
                <Popover open={openDtPrevision} onOpenChange={setOpenDtPrevision}>
                  <PopoverTrigger asChild>
                    <FormControl>
                      <Button
                        variant={'outline'}
                        className={cn(
                          'w-full pl-3 text-left font-normal',
                          !field.value && 'text-muted-foreground'
                        )}
                      >
                        {field.value ? (
                          format(field.value, 'PPP', {locale: ptBR})
                        ) : (
                          <span>Escolha uma data</span> 
                        )}
                        <CalendarIcon className="ml-1 h-4 w-4 opacity-50" />
                      </Button>
                    </FormControl>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-0" align="start">
                    <Calendar
                      mode="single"
                      selected={field.value}
                      onSelect={field.onChange}
                      onDayClick={(date) => {
                        setOpenDtPrevision(false);
                        form.setValue('prevision', date);
                        setDataTaskEdit(form.getValues());
                      }}
                      disabled={(date) => {
                        const dtinicio = form.getValues().iniciatedAt;
                        if (!dtinicio) return true;
                        return date < dtinicio;
                      }}
                        
                      initialFocus
                      locale={ptBR}
                    />
                  </PopoverContent>
                </Popover>
                <FormMessage />
              </FormItem>
            )}
          />

          {/** Tipo da Tarefa */}
          <FormField
            control={form.control}
            name='activityTypesId'
            render={({ field }) => (
              <FormItem>
                <FormLabel>Tipo de Atividade</FormLabel>
                <FormControl>
                  <Select 
                    onValueChange={field.onChange} 
                    //defaultValue={dataTaskEdit != undefined && dataTaskEdit ? dataTaskEdit.activityTypesId.toString() : field.value}
                    >
                    <SelectTrigger>
                      <SelectValue placeholder="Selecione um tipo" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        {types.map((tipo, index) => (
                          <SelectItem key={index} value={tipo.id.toString()}>
                            <SelectLabel className='p-2 font-normal'>{tipo.description}</SelectLabel>
                          </SelectItem>
                        ))}
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          {/** Prioridade */}
          <FormField
            control={form.control}
            name="setPriority"
            render={({ field }) => (
              <FormItem className="space-y-3">
                <FormLabel>Prioridade</FormLabel>
                <FormControl>
                  <RadioGroup
                    onValueChange={field.onChange}
                    defaultValue={dataTaskEdit ? dataTaskEdit.setPriority : ''}
                    className="flex flex-row items-center gap-4"
                  >
                    <FormItem className="flex items-center space-x-2 space-y-0">
                      <FormControl>
                        <RadioGroupItem value="Baixa" />
                      </FormControl>
                      <FormLabel className="font-normal">
                        Baixa
                      </FormLabel>
                    </FormItem>
                    <FormItem className="flex items-center space-x-2 space-y-0">
                      <FormControl>
                        <RadioGroupItem value="Normal" />
                      </FormControl>
                      <FormLabel className="font-normal">
                        Normal
                      </FormLabel>
                    </FormItem>
                    <FormItem className="flex items-center space-x-2 space-y-0">
                      <FormControl>
                        <RadioGroupItem value="Alta" />
                      </FormControl>
                      <FormLabel className="font-normal">
                        Alta
                      </FormLabel>
                    </FormItem>
                  </RadioGroup>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          {/** Observação */}
          <FormField
            control={form.control}
            name="observation"
            render={({ field }) => (
              <FormItem className='flex flex-col w-full'>
                <FormLabel>Observação</FormLabel>
                <FormControl>
                  <Textarea
                    placeholder="Observação da tarefa"
                    className="resize-none"
                    defaultValue={dataTaskEdit ? dataTaskEdit.observation : ''}
                    {...field}
                  />
                </FormControl>
              </FormItem>
            )}
          />

          {/** Feito */}
          <FormField
            control={form.control}
            name='done'
            render={({ field }) => (
              <FormItem>
                <FormLabel>Tarefa Concluída</FormLabel>
                <FormControl>
                  <Select 
                    onValueChange={field.onChange}
                    defaultValue={dataTaskEdit ? dataTaskEdit.done : field.value}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Selecione"/>
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        {dones.map((tipo, index) => (
                          <SelectItem key={index} value={tipo.id}>
                            <SelectLabel className='p-2 font-normal'>{tipo.display}</SelectLabel>
                          </SelectItem>
                        ))}
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          {/** Notificação */}
          <FormField
            control={form.control}
            name="notification"
            render={({ field }) => (
              <FormItem className="flex flex-col justify-between mt-2">
                <FormLabel className="text-sm">
                  Ativar notificações
                </FormLabel>
                <FormControl>
                  <Switch
                    checked={field.value}
                    defaultChecked = {dataTaskEdit ? dataTaskEdit.setNotification : field.value}
                    onCheckedChange={field.onChange}
                  />
                </FormControl>
              </FormItem>
            )}
          />
            
          <Button type='submit' className='w-2/6 my-4 mx-auto' onClick={()=>{
            
            form.setValue('businessId', leadId);
            form.setValue('situation', 1);
            form.setValue('userWhoAdds', loggedUser ? loggedUser : '');
            
            if(form.getValues().done === 'S'){
              setIsCompleted(true);
            } else{
              setIsCompleted(false);
            }

            if(form.getValues().setPriority === 'Baixa'){
              form.setValue('priority', 0);
            }else if(form.getValues().setPriority === 'Normal'){
              form.setValue('priority', 1);
            }else if(form.getValues().setPriority === 'Alta'){
              form.setValue('priority', 2);
            }


            if(!form.getValues().iniciatedAt){
              form.setValue('prevision', undefined);
              form.setValue('conclusionAt', undefined);
            }
            if(form.getValues().activityTypesId){
              const type = types.find((t) => t.id === Number(form.getValues().activityTypesId))?.description;
              if(type) form.setValue('activityType', type);
            }  
            if(form.getValues().userId){
              const name = users.find((u) => u.userId === Number(form.getValues().userId))?.name;
              if(name) form.setValue('userName', name);
            }
          }}>{buttonLabel}</Button>
        </form>
      </Form>
    </div>
  );
};

export default FormTarefa;
